import React from 'react';
import { AdUnit, ADSENSE_CONFIG } from '../../ads';
import './PageLayout.css';

interface PageLayoutProps {
  children: React.ReactNode;
  showAds?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, showAds = false }) => {
  return (
    <div className="page-layout">
      <div className="page-layout-container">
        {showAds && (
          <div className="page-layout-ad-left">
            <AdUnit 
              slotId={ADSENSE_CONFIG.slots.leftSidebar || undefined}
              format="skyscraper"
            />
          </div>
        )}
        
        <main className="page-layout-content">
          {children}
        </main>
        
        {showAds && (
          <div className="page-layout-ad-right">
            <AdUnit 
              slotId={ADSENSE_CONFIG.slots.rightSidebar || undefined}
              format="skyscraper"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PageLayout; 